import { render, staticRenderFns } from "./candidate-filter-menu.vue?vue&type=template&id=f97f4bd0"
import script from "./candidate-filter-menu.vue?vue&type=script&lang=js"
export * from "./candidate-filter-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports